import React, { useState, useEffect } from 'react';

const STORES = [
  { id: 6, name: 'Niko 1' },
  { id: 3, name: 'Niko 2' },
  { id: 1, name: 'Niko 3' },
  { id: 2, name: 'Niko 4' },
  { id: 4, name: 'Niko 5' },
  { id: 5, name: 'Niko 7' },
];

type Summary = {
  store_id: number;
  store_name: string;
  rating: number | null;
  user_rating_count: number | null;
  updated_at: string;
};

type Review = {
  id: number;
  author: string;
  rating: number | null;
  review_text: string | null;
  published_at: string;
  fetched_at: string;
};

export default function ReviewsPanel() {
  const [summary, setSummary] = useState<Summary[]>([]);
  const [sid, setSid] = useState<number>(6);
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(false);
  const tok = localStorage.getItem('token') || localStorage.getItem('pc_token') || '';

  const loadSummary = async () => {
    try {
      const r = await fetch('/api/reviews/summary', { headers: { Authorization: 'Bearer ' + tok } });
      setSummary(await r.json());
    } catch (e) {}
  };

  const loadReviews = async (storeId: number) => {
    setLoading(true);
    try {
      const p = new URLSearchParams({ store_id: storeId.toString(), limit: '15' });
      const r = await fetch('/api/reviews?' + p, { headers: { Authorization: 'Bearer ' + tok } });
      setReviews(await r.json());
    } catch (e) {}
    setLoading(false);
  };

  useEffect(() => { loadSummary(); }, []);
  useEffect(() => { loadReviews(sid); }, [sid]);

  const fmtFecha = (iso: string) => {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString('es-AR'); } catch { return iso; }
  };

  return (
    <div style={{ padding: 24, background: '#f0f2f5', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: '#1a1a2e' }}>Reseñas de Google</h1>
          <p style={{ margin: '4px 0 0', color: '#666', fontSize: 14 }}>Rating y opiniones por local, actualizado todos los días</p>
        </div>
        <button onClick={() => { loadSummary(); loadReviews(sid); }} style={{ padding: '8px 16px', borderRadius: 8, background: '#1a1a2e', color: '#fff', border: 'none', cursor: 'pointer' }}>
          {loading ? '...' : 'Actualizar'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
        {STORES.map((s) => {
          const item = summary.find((x) => x.store_id === s.id);
          return (
            <div
              key={s.id}
              onClick={() => setSid(s.id)}
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: 16,
                boxShadow: sid === s.id ? '0 0 0 2px #1a1a2e' : '0 2px 8px rgba(0,0,0,0.06)',
                cursor: 'pointer',
              }}
            >
              <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>{s.name}</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#1a1a2e' }}>
                {item?.rating != null ? Number(item.rating).toFixed(1) : '—'} ★
              </div>
              <div style={{ fontSize: 12, color: '#999' }}>
                {item?.user_rating_count != null ? `${item.user_rating_count} opiniones` : 'sin datos'}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>
          Últimas reseñas — {STORES.find((s) => s.id === sid)?.name}
        </h3>
        {loading && <div style={{ color: '#999', fontSize: 13 }}>Cargando...</div>}
        {!loading && reviews.length === 0 && (
          <div style={{ color: '#999', fontSize: 13 }}>No hay reseñas registradas todavía para este local.</div>
        )}
        {!loading && reviews.map((r) => (
          <div key={r.id} style={{ marginBottom: 16, paddingBottom: 16, borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
              <span style={{ fontWeight: 600, fontSize: 13 }}>{r.author}</span>
              <span style={{ fontSize: 12, color: '#999' }}>{fmtFecha(r.published_at)}</span>
            </div>
            <div style={{ color: '#f59e0b', fontSize: 13, marginBottom: 4 }}>
              {'★'.repeat(r.rating || 0)}{'☆'.repeat(5 - (r.rating || 0))}
            </div>
            <div style={{ color: '#475569', fontSize: 13, lineHeight: 1.5 }}>
              {r.review_text || '(sin texto)'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
